module.exports = __webpack_public_path__ + "img/upskilling.4465a697.svg";